<template>
  <div class="structure-item">
    <div class="d-flex align-start py-3 column-gap-2">
      <div 
        v-if="hasChildren"
        class="expand-icon-wrapper flex-shrink-0"
        @click="toggleExpanded"
      >
        <app-icon
          size="small"
          icon-weight="fas"
          :icon-name="expanded ? 'caret-down' : 'caret-right'"
          class="expand-icon"
        />
      </div>
      <div v-else class="expand-icon-placeholder flex-shrink-0"></div>
      
      <span class="item-title" :class="{ 'font-weight-medium': item.type === 'title' }">{{ item.numbering }} {{ item.title }}</span>
      
      <v-chip 
        class="ml-auto flex-shrink-0"
        size="small" 
        :color="item.type === 'title' ? 'purple' : 'info'" 
        variant="tonal"
      >
        {{ item.type === 'title' ? $t('project.checklist.dialogs.SmartImportStructureItem.title') : $t('project.checklist.dialogs.SmartImportStructureItem.task') }}
      </v-chip>
    </div>

    <div v-if="hasChildren && expanded">
      <SmartImportStructureItem
        v-for="child in item.children"
        :key="child.id"
        :item="child"
        :level="level + 1"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from 'vue'

interface StructureItem {
  id: string
  title: string
  type: 'title' | 'task'
  children?: StructureItem[]
  numbering: string
}

export default defineComponent({
  name: 'SmartImportStructureItem',
  props: {
    item: {
      type: Object as PropType<StructureItem>,
      required: true,
    },
    level: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const expanded = ref(true)
    const hasChildren = ref(props.item.children && props.item.children.length > 0)

    const toggleExpanded = () => {
      expanded.value = !expanded.value
    }

    return {
      expanded,
      hasChildren,
      toggleExpanded,
    }
  },
})
</script>

<style lang="scss" scoped>
.structure-item {
  .item-title {
    flex: 1;
    min-width: 0;
    word-break: break-word;
    line-height: 1.4;
  }

  .expand-icon-wrapper {
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .expand-icon {
    pointer-events: none;
  }

  .expand-icon-placeholder {
    width: 16px;
  }

  .v-chip {
    border-radius: 4px;
    height: 20px;
    font-weight: bold;
    font-size: 12px;
    padding: 0 8px;
  }
}
</style>
